import React, { ReactNode, useEffect, useMemo, useState } from "react";
import { useCustomPropertiesFilter } from "../../../state/FilterContext";
import { useArrayContext } from "../../../state/ArrayContext";
import { SourceItem } from "../../../shared/models/source-item.model";
import { PropertiesModel, PropertyValue } from "../../../shared/models/metadata.model";
import { TextExtractor, findFirstComponentOfType } from "../../internal/TextExtractor";

interface CustomPropertyFilterValuesProps {
    propertyNameArg?: string | null,
    children?: ReactNode,
}

/***
 * Array source that returns the values of a filter for a custom property.
 */
export const CustomPropertyFilterValues = React.memo(function CustomPropertyFilterValues({ propertyNameArg, children }: CustomPropertyFilterValuesProps): React.ReactElement {
    const { setArray } = useArrayContext();
    const customProperties: PropertiesModel = useCustomPropertiesFilter();

    // Get the property name from the property child
    const [propertyName, setPropertyName] = useState("");
    const propertyChild = useMemo(() => propertyNameArg ? null : findFirstComponentOfType(children, "arg-property"), [children, propertyNameArg]);

    useEffect(() => {
        const usedPropertyName = propertyNameArg || propertyName;
        if (usedPropertyName) {
            let values: Array<SourceItem> = [];
            values = customProperties?.[usedPropertyName]?.map((value: PropertyValue, ix: number) => {
                return {
                    value: value,
                    props: {},
                    position: ix + 1,
                };
            }) || [];
            setArray(values);
        }
    }, [customProperties, propertyName, propertyNameArg, setArray]);

    return <>
        <TextExtractor onExtractedText={setPropertyName}>
            {propertyChild?.props.children}
        </TextExtractor>
    </>;
});